import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function User() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit user` : type === "profile" ? `Profile` : 'Add user'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get user
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/user/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setUserData(response.data[0])
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/user`, {
                ...data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/user/${id}`, {
                ...data,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [userData, setUserData] = useState<any>(type === 'edit' ? [] : type === 'profile' ?
        {
            "id": null,
            "username": null,
            "partnerbank": null,
            "accesslevel": null,
            "lastname": null,
            "firstname": null,
            "middlename": null,
            "email": null,
            "jobtitle": null,
            "businessphone": null,
            "mobilephone": null,

        }
        :
        {
            "id": null,
            "username": null,
            "partnerbank": null,
            "password": null,
            "accesslevel": null,
            "lastname": null,
            "firstname": null,
            "middlename": null,
            "email": null,
            "jobtitle": null,
            "businessphone": null,
            "mobilephone": null,

        }
    )

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setSPartners(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        type === 'profile' && fetchData()
        type === 'edit' && fetchData()
        getPartners()
        console.log(userData);

    }, [type])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 220, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField disabled={accesslevel !== '1' && accesslevel !== '2'} error={userData.username === null} onChange={(e) => setUserData({ ...userData, username: e.target.value !== '' ? e.target.value : null })} value={userData.username || ''} variant="outlined" size="small" label='Username*' />
                    {((accesslevel === '1' || accesslevel === '2') && type !== 'profile') && <TextField error={userData.password === null} type="password" onChange={(e) => setUserData({ ...userData, password: e.target.value !== '' ? e.target.value : null })} value={userData.password || ''} variant="outlined" size="small" label='Password*' />}
                    {accesslevel === '1' && <FormControl>
                        <InputLabel size="small" id="simple-select-label">Partner</InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setUserData({ ...userData, partnerbank: e.target.value !== "" ? e.target.value : null })} value={userData.partnerbank || ''} variant="outlined" size="small" label='Partner' >
                            <MenuItem value={''}>Not selected</MenuItem>
                            {
                                partners.map((el: any) => {
                                    return (
                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>}
                    <FormControl>
                        <InputLabel sx={{ color: userData.accesslevel === null ? '#d32f2f' : "#c4c4c4" }} size="small" id="simple-select-label">Accsess level*</InputLabel>
                        <Select disabled={accesslevel !== '1' && accesslevel !== '2'} error={userData.accesslevel === null} sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setUserData({ ...userData, accesslevel: e.target.value !== "" ? e.target.value : null })} value={userData.accesslevel || ''} variant="outlined" size="small" label='Accsess level*' >
                            {accesslevel === '1' && <MenuItem value={'1'}>Global admin</MenuItem>}
                            <MenuItem value={'2'}>Bank admin</MenuItem>
                            <MenuItem value={'3'}>Bank backoffice</MenuItem>
                            {(accesslevel === '1' || accesslevel === '5') && <MenuItem value={'4'}>Bank operator</MenuItem>}
                            {(accesslevel === '1' || accesslevel === '5') && <MenuItem value={'5'}>Card Garant operator</MenuItem>}
                            {(accesslevel === '1' || accesslevel === '5') && <MenuItem value={'6'}>Inactive</MenuItem>}
                        </Select>
                    </FormControl>
                    <TextField disabled={accesslevel !== '1' && accesslevel !== '2'} error={userData.lastname === null} onChange={(e) => setUserData({ ...userData, lastname: e.target.value !== '' ? e.target.value : null })} value={userData.lastname || ''} variant="outlined" size="small" label='Lastname*' />
                    <TextField disabled={accesslevel !== '1' && accesslevel !== '2'} error={userData.firstname === null} onChange={(e) => setUserData({ ...userData, firstname: e.target.value !== '' ? e.target.value : null })} value={userData.firstname || ''} variant="outlined" size="small" label='Firstname*' />
                    <TextField disabled={accesslevel !== '1' && accesslevel !== '2'} onChange={(e) => setUserData({ ...userData, middlename: e.target.value !== '' ? e.target.value : null })} value={userData.middlename || ''} variant="outlined" size="small" label='Middlename' />
                    <TextField disabled={accesslevel !== '1' && accesslevel !== '2'} onChange={(e) => setUserData({ ...userData, email: e.target.value !== '' ? e.target.value : null })} value={userData.email || ''} variant="outlined" size="small" label='E-mail' />
                    <TextField disabled={accesslevel !== '1' && accesslevel !== '2'} onChange={(e) => setUserData({ ...userData, jobtitle: e.target.value !== '' ? e.target.value : null })} value={userData.jobtitle || ''} variant="outlined" size="small" label='Job title' />
                    <TextField disabled={accesslevel !== '1' && accesslevel !== '2'} onChange={(e) => setUserData({ ...userData, businessphone: e.target.value !== '' ? e.target.value : null })} value={userData.businessphone || ''} variant="outlined" size="small" label='Business phone' />
                    <TextField disabled={accesslevel !== '1' && accesslevel !== '2'} onChange={(e) => setUserData({ ...userData, mobilephone: e.target.value !== '' ? e.target.value : null })} value={userData.mobilephone || ''} variant="outlined" size="small" label='Mobile phone' />
                </Box>
                {(accesslevel === '1' || accesslevel === '2') && <Button onClick={() => type === "edit" ? putData(userData) : type === "profile" ? putData(userData) : postData(userData)} variant="contained" sx={{ width: "100%" }}>Save</Button>}
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/users' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        Saving error
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Successfully saved
                    </Alert>}
            </Snackbar>
        </Box >
    )
}